import "./index.0.css";
import { lazyRenderMixin } from "../../../../lib/helpers";
const __script_base__ = {
  mixins: [lazyRenderMixin],
  name: 'WParagraph',
  props: {
    align: {
      type: String,
      default: 'left'
    },
    valign: {
      type: String,
      default: 'top'
    },
    noWrap: {
      type: Boolean,
      default: false
    },
    gap: {
      type: String,
      default: ''
    },
    css: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasClick() {
      return !!this.$listeners.click;
    },
    mergedCss() {
      const s = [];
      if (this.gap) s.push(`gap: ${this.gap}`);
      if (this.css) s.push(this.css);
      return s.join(';\n');
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    ref: "container",
    staticClass: "w-paragraph",
    class: {
      hasClick: _vm.hasClick,
      noWrap: _vm.noWrap
    },
    style: _vm.mergedCss,
    attrs: {
      "data-align": _vm.align,
      "data-valign": _vm.valign
    },
    on: {
      click: function ($event) {
        return _vm.$emit("click", this);
      },
      mouseenter: function ($event) {
        return _vm.$emit("mouseenter", this);
      },
      mouseleave: function ($event) {
        return _vm.$emit("mouseleave", this);
      }
    }
  }, [_vm.renderSlot ? _vm._t("default") : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Paragraph/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);